import React from "react";
import Home from "./components/Home/Home";
import { BrowserRouter, Switch } from "react-router-dom";
// import { DataContext } from "../src/components/shared/Shared";
import "./App.css";

export default function App() {

  return (
    <BrowserRouter>
      <Switch>
        <div className="containAll" style={{width:"100%", display:"flex",flexDirection:"column",justifyContent:"center" }}>
          <Home />
        </div>
      </Switch>
    </BrowserRouter>
  );
}
